import React, { useState, useCallback, useEffect } from 'react'
import AutocompleteNative from '@material-ui/lab/Autocomplete'
import { TextField, Checkbox } from '@material-ui/core'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

export const SelectStatusReq = (props) => {
  const options = [
    { label: 'PENDENTE', value: 'PENDENTE' },
    { label: 'EM PROCESSAMENTO', value: 'EM_PROCESSAMENTO' },
    { label: 'PROCESSADO', value: 'PROCESSADO' },
  ]
  const { statusSelecionado, setStatusSelecionado, label } = props
  const [inputStatus, setInputStatus] = useState('')
  const [listaOpcoesStatusFiltros, setListaOpcoesStatusFiltros] = useState('')

  const handleChangeInputStatus = useCallback((value) => {
    setInputStatus(value)
    if (value?.length > 2) {
      setListaOpcoesStatusFiltros((prevState) =>
        options.filter((status) => {
          if (status.label.includes(value?.toUpperCase()) || status.value.includes(value?.toUpperCase())) {
            return status
          }
        })
      )
    } else {
      setListaOpcoesStatusFiltros(null)
    }
  }, [])

  return (
    <AutocompleteNative
      value={options.find((objeto) => objeto.value === statusSelecionado) || { label: '', value: '' }}
      name="status"
      options={listaOpcoesStatusFiltros || options}
      onChange={(event, newValue) => {
        if (newValue !== null) {
          const { value } = newValue
          setStatusSelecionado(value)
        } else {
          setStatusSelecionado('')
        }
      }}
      getOptionSelected={(option, value) => option.value === value.value}
      getOptionLabel={(option) => `${option.label}`}
      renderOption={(option, { selected }) => (
        <>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{
              marginRight: 8,
            }}
            checked={selected}
          />
          {`${option.label}`}
        </>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={label}
          InputLabelProps={{
            shrink: true,
          }}
          value={inputStatus}
          onChange={(e) => handleChangeInputStatus(e.target.value)}
        />
      )}
    />
  )
}
